import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import CataloguePage from './pages/CataloguePage';
import ProductPage from './pages/ProductPage';
import LoginPage from './pages/LoginPage';
import DashboardAcheteur from './pages/DashboardAcheteur';
import DashboardVendeur from './pages/DashboardVendeur';
import AdminPage from './pages/AdminPage';
import AnnoncePage from './pages/AnnoncePage';
import './App.css';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/catalogue" element={<CataloguePage />} />
        <Route path="/produit/:id" element={<ProductPage />} />
        <Route path="/connexion" element={<LoginPage />} />
        <Route path="/mon-compte" element={<DashboardAcheteur />} />
        <Route path="/vendeur" element={<DashboardVendeur />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/deposer-annonce" element={<AnnoncePage />} />
      </Routes>
    </Router>
  );
}

export default App;